export default "/images/vendor/flag-icon-css/flags/1x1/pr.svg?836bcb814711de3da2063e866565340a";